module.exports = __webpack_public_path__ + "static/media/kitkat.8751400d.jpeg";